<template>
  <div :class="'md-layout'">
    <modal v-if="type.selecting" @close="type.selecting = false" :closeOutside="false">
      <template slot="header">
        <h4 :class="'modal-title'">Select review type</h4>
      </template>

      <template slot="body">
        <div :class="'md-layout-item'">
          <md-radio v-model="type.value" :value="1">Risk and Quality Review</md-radio>
        </div>
      </template>

      <template slot="footer">
        <md-button :class="'md-danger'" @click="type.selecting = false">Ok</md-button>
      </template>
    </modal>

    <md-card v-if="!type.selecting">
      <md-card-header :class="'md-card-header-icon md-card-header-danger'">
        <div :class="'card-icon'">
          <md-icon>mail_outline</md-icon>
        </div>
        <h4 :class="'title'">
          <span v-if="type.value === 1">Advisory Risk and Quality Review</span>
        </h4>
      </md-card-header>
      <md-card-content v-if="type.value === 1">
        <advisory-risk-and-quality></advisory-risk-and-quality>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
  import { Modal } from '@/components'
  import AdvisoryRiskAndQuality from './AdvisoryRiskAndQuality/Create.vue'

  export default {
    components: {
      Modal,
      AdvisoryRiskAndQuality
    },

    data () {
      return {
        type: {
          selecting: true,
          value: 1,
        }
      }
    },

    created() {
      // Makes a base to add eventually multiple types.
      // Here, we just skip directly to the first one created.
      this.type.selecting = false
    },
  }
</script>
